import { canSetMainAdvisor } from "web_myplann/Advisor/Utils/canSetMainAdvisor";
import { useAdvisorSetMainMutation } from "web_myplann/Api/Advisor/useAdvisorSetMainMutation";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const useSetMainAdvisor = (
	advisor?: AgentAssignedListItemResponseDTO,
) => {
	const { mutate: setMain, isPending } = useAdvisorSetMainMutation();

	const confirmSetMain = (
		confirmedAdvisor: AgentAssignedListItemResponseDTO,
		onSuccess: () => void,
	) => {
		setMain(confirmedAdvisor.id, { onSuccess });
	};

	return {
		canSetMain: canSetMainAdvisor(advisor),
		isPending,
		confirmSetMain,
	};
};
